import { Component, computed, inject, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FormFieldService } from '../../../services/form-field/form-field.service';
import { LangService } from 'src/app/shared/services/lang/lang.service';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { ExtendedKeyUsages } from 'src/app/shared/entities/extended-key-usages';
import { ExtendedKeyUsagesFormFieldOptions } from '../../../form-field.types';

@Component({
  selector: 'app-extended-key-usage-form-field',
  imports: [ReactiveFormsModule, MatCheckboxModule, MatExpansionModule],
  templateUrl: './extended-key-usage-form-field.component.html',
  styleUrl: './extended-key-usage-form-field.component.scss',
})
export class ExtendedKeyUsageFormFieldComponent {
  private formFieldService = inject(FormFieldService);
  private langService = inject(LangService);
  private openByDefault = true;

  title = this.langService.lang.shared.extendedKeyUsageTitle;
  criticalKeyUsageLabel = this.langService.lang.shared.criticalKeyUsageLabel;
  usageLabels: Record<ExtendedKeyUsages, string> =
    this.langService.lang.shared.extendedKeyUsages;

  keyUsages = Object.values(ExtendedKeyUsages);

  name = input('');
  path = input<string>();
  options = input<ExtendedKeyUsagesFormFieldOptions>();
  expanded = computed(() => {
    const open = this.options()?.open;
    return (open === undefined && this.openByDefault) || open;
  });

  formGroup = this.formFieldService.formGroup;
  control = computed(() => {
    const path = this.path() ?? this.name();
    const formGroup = this.formGroup();
    return formGroup?.get(path) as FormGroup;
  });
  keyUsagesGroup = computed(
    () => this.control()?.get('extendedKeyUsages') as FormGroup,
  );
}
